import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f29bb16a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-flush" }
const _hoisted_2 = { class: "px-7 pt-5 pb-1 d-row border-bottom" }
const _hoisted_3 = { class: "card-title d-flex align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder" }
const _hoisted_5 = {
  key: 0,
  class: "recent-activity-list"
}
const _hoisted_6 = { class: "recent-activity-text" }
const _hoisted_7 = { class: "recent-activity-title" }
const _hoisted_8 = {
  key: 0,
  class: "recent-activity-subtitle"
}
const _hoisted_9 = { class: "recent-activity-time" }
const _hoisted_10 = {
  key: 1,
  class: "recent-activity-empty"
}
const _hoisted_11 = { class: "fw-bold fs-6 text-center px-6" }

import moment from "moment";

type TimelineItem = {
  type: string;
  item_name?: string;
  title?: string;
  points?: number;
  created_at: string;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    timeline: null,
    title: null,
    emptyLabel: null,
    lessonLabel: null,
    challengeLabel: null,
    machineLabel: null
  },
  setup(__props: any) {

const props = __props as {
  timeline: TimelineItem[];
  title: string;
  emptyLabel: string;
  lessonLabel: string;
  challengeLabel: string;
  machineLabel: string;
}



const typeTitle = (type: string) => {
  if (type === "finished_lesson") return props.lessonLabel;
  if (type === "ownned_challenge") return props.challengeLabel;
  return props.machineLabel;
};

const typeIcon = (type: string) => {
  if (type === "finished_lesson") return "bi-play-circle-fill activity-icon-success";
  if (type === "ownned_challenge") return "bi-play-circle-fill activity-icon-primary";
  return "bi-cpu activity-icon-danger";
};

const subtitle = (item: TimelineItem) => item.item_name || item.title || "";

const relativeTime = (date: string) => moment(date).fromNow();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.title), 1)
      ])
    ]),
    (__props.timeline.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.timeline, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "recent-activity-row"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["bi recent-activity-icon", typeIcon(item.type)])
              }, null, 2),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(typeTitle(item.type)), 1),
                (subtitle(item))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(subtitle(item)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(relativeTime(item.created_at)), 1)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(__props.emptyLabel), 1)
        ]))
  ]))
}
}

})